import React from 'react';
import styles from './FeaturesSection.module.scss';
import { Section } from '../../../Landings/Section';
import { FeatureItem } from './FeatureItem';
import { CtaButton } from '../CtaButton';
import { socialMediaIcons } from '@/src/shared/constants/socials';
import { MAX_VIDEO_RECORD_SECONDS_DURATION } from '../../utils/constants';

export default function FeaturesSection() {
  return (
    <Section className={styles.container}>
      <h1 className={styles.title}>Features</h1>
      <div className={styles.cards}>
        <FeatureItem
          imageSrc={socialMediaIcons.gray[900].instagram}
          title="Social Media Automation"
          description="Post content to all your social media channels every days"
          href={''}
        />
        <FeatureItem
          title="Customize Design"
          description="More ways to style your content and make your brand pop"
          icon="palette"
          href={''}
        />
        <FeatureItem
          icon="mail-02"
          title="Email Campaign"
          description="Weekly newsletter to your mailing list"
          href={''}
        />
        <FeatureItem
          icon="phone-01"
          title="Personal Intro"
          description={`${MAX_VIDEO_RECORD_SECONDS_DURATION}-sec Personal Intro or Face Message`}
          href={''}
        />
        <FeatureItem
          icon="users-01"
          title="Call with AI"
          description="Lead Management, Lead follow-up with video, Respond to leads by A.I."
          href={''}
        />
        <FeatureItem
          icon="translate-02"
          title="Multilingual Videos"
          description="Engage your audience with videos in 20+ languages."
          href={''}
        />
      </div>
      <CtaButton className={styles.cta} />
    </Section>
  );
}
